export default __webpack_public_path__ + "static/media/greenTick.d341a0e5.svg";